import mirrorObject from "@/util/mirror-object.mjs";

const ANALYTIC_EVENTS = mirrorObject([
  "APP_CLIENT_ERROR",
  "SESSION",
  "PAGE_VIEW",
  "USER_SPEC_UPDATE",
  "USER_LOC_UPDATE",
  "MOUSEOVER",
  "SCROLLING",
  "SEARCH",
  "IFRAME_CLICKED",
  "USER_INTERACTION",
  "FEATURE_VERSION",

  "LOL_WIDGET",
  "LOL_START",
  "LOL_END",
  "LOL_BUILD_IMPORT",

  "LOL_IMPORT_ERROR_RUNES",
  "LOL_IMPORT_SUCCESS_RUNES",
  "LOL_IMPORT_ERROR_SPELLS",
  "LOL_IMPORT_SUCCESS_SPELLS",

  "LOL_ARENA_POSTMATCH",
  "LOL_BRAWL_POSTMATCH",
  "LOL_ARAM_MAYHEM_POSTMATCH",
  "LOL_COACHING_POSTMATCH",
  "LOL_TIMELINE_LOADED",
  "LOL_SEASON_VIEW",
  "LOL_FRIENDS",

  "TFT_START",
  "TFT_END",
  "TFT_POSTMATCH",
  "TFT_LP_CHANGE",
  "TFT_ROUND_DATA",
  "TFT_OVERLAY_USAGE",

  "VAL_START",
  "VAL_END",
  "VAL_LOADING_SCREEN",
  "VAL_MATCH_REVERSED_STATS",

  "APEX_START",
  "APEX_END",

  "CSGO_START",
  "CSGO_END",

  // FORTNITE
  "FRT_START",
  "FRT_END",
  "FORTNITE_INVENTORY",
  "FORTNITE_ITEM_SHARE",

  // EFT
  "EFT_START",
  "EFT_END",

  // DEADLOCK
  "DL_HEARTBEAT",
  "DL_START",
  "DL_END",
  "DL_MATCH_METADATA",

  // MINECRAFT
  "MC_HEARTBEAT",

  // MARVEL RIVALS
  "MR_START",
  "MR_END",
  "MR_HEARTBEAT",

  // ROCKET LEAGUE
  "ROCKET_RUNNING",
  "ROCKET_START",
  "ROCKET_END",

  // TODO: @korbinancell coordinate w/ data to update this for battles
  "ARENA_CLICK",
  "ARENA_AD_IMPRESSION",

  "MATCH_PRO_NATIVE_VIEW",
  "MATCH_PRO_NATIVE_CLICK",
  "PRO_CONVERSION",

  "NETWORK_ERROR",
  "RESOURCE_USAGE",
  "RESOURCE_USAGE_RAM_ARRAY",
  "PERFORMANCE_TIMING",
  "OVERLAY_VISIBILITY",
  "UNINSTALL_SURVEY",
  "HIGH_MEMORY_REFRESH",
  "TIMED_REFRESH",

  // partially done; TODO: utm info
  "APP_DOWNLOAD",

  // TODO with utm info
  "DOWNLOAD_ERROR",
  // GAME WINDOWS
  "GAME_START",
  "GAME_EXIT",

  // AD EVENTS
  "AD_IMPRESSION",
  "AD_VIDEO_IMPRESSION",
  "AD_VIDEO_ERROR",
  "AD_TRACK_VIDEO_PROVIDER",
  "AD_REPORT",

  // Marketing
  "COMING_SOON_LAUNCH_EMAIL",
  "PROMO_MODAL_CLOSE",
  "MATCH_TILES_SHARING",

  // TODO --------------------------------------------
  "USER_LOGIN",
  "USER_LOGOUT",
  "TFT_STATS",
  "VAL_STATS",
  "VAL_AGENT_SELECT_AD",
  "VAL_LOADING_SCREEN_AD",

  // -------------------------------------------------

  // no coresponse function | deprecated | defined but not used in blitz-web
  // LOR_START: 'LOR_START',
  // LOR_END: 'LOR_END',
  // FRT_STATS: 'FRT_STATS',
  // PARTNER_EVENT_GRUBHUB_EVENTS_HEADER: 'partnerEventGrubhubApp-eventsHeader',
  // PARTNER_EVENT_GRUBHUB_PROFILE_BTN_VIEW_MISSIONS:
  //   'partnerEventGrubhubProfile-btnViewMissions',
  // OVERLAY_STATS: 'Overlay Stats',
  // MONITOR_VIEW: 'Monitor_View',
  // PARTNER_EVENT_GRUBHUB_EVENT_DETAILS_BTN_QUEUE:
  //   'partnerEventGrubhubEventDetails-btnQueue',
  // GOOGLE_ANALYTICS: 'GOOGLE_ANALYTICS',
  // LOL_ACCOLADES: 'LOL_ACCOLADES',
  // LOL_STATS: 'LOL_STATS',
  // LOL_DRAFT: 'LOL_DRAFT',
  // LOL_MATCH: 'LOL_MATCH',
  // CHAMPION_SELECT_BUILD_SWAPPED_TO_PRO:
  //   'Champion Select - Build swapped to Pro',
  // ACCEPT_QUEUE_CLICKS: 'Accept_Queue_Clicks',
  // ACCEPT_QUEUE_CLICK_COUNT: 'ACCEPT_QUEUE_CLICK_COUNT',
  // AD_VIEW_VIDEO: 'AD_VIEW_VIDEO',
  // CHALLENGES_MODAL: 'CHALLENGES_MODAL',
  // ARAM_REROLL: 'ARAM_REROLL',
  // CHAMPION_BAN: 'CHAMPION_BAN',
  // CHAMPION_DECLARE: 'CHAMPION_DECLARE',
  // CHAMPION_LOCKIN: 'CHAMPION_LOCKIN',
  // CHAMPION_TRADE_REQUEST: 'CHAMPION_TRADE_REQUEST',
  // CHAMPION_TRADE_RESPONSE: 'CHAMPION_TRADE_RESPONSE',
  // MATCH_FOUND: 'MATCH_FOUND',
  // APP_CRASH: 'APP_CRASH',

  // disabled for too spammy
  // CLICK_TRACKING: 'CLICK_TRACKING',
  // LOL_STORE_VIEW: 'LOL_STORE_VIEW',

  // cn specific:
  // LOL_POSTMATCH: 'LOL_POSTMATCH',
]);

export default ANALYTIC_EVENTS;
